import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { fixedIncomeMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { transformCustomCategories, transformCustomFilters } from '../../../../constants';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import {
  dailyLiquidityCaption,
  fgcProtectedCaption,
  qualifiedInvestorCaption,
  taxExemptCaption,
} from '../../../AssetCaptions/constants';
import {
  getRiskRatingLevelFilter,
  profitabilityTypeFilter,
  dailyLiquidityFilter,
  taxExemptFilter,
  applicationAmountFilterNew,
  monthsToRedemptionFilter,
  marketOptionFilter,
} from '../../../AssetFilters/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { FixedIncomeAsset } from '.';

const fixedIncomeCaptions: AssetCaptionType[] = [
  qualifiedInvestorCaption,
  taxExemptCaption,
  dailyLiquidityCaption,
  fgcProtectedCaption,
];

export const fixedIncomeTableHead: TableHeadItemRecurse[] = [
  { title: 'Taxa-spread', orderValue: 'profitabilityFormatted' },
  { title: 'Rentabilidade anual', orderValue: 'profitabilityYearly' },
  { title: 'Aplicação', orderValue: 'applicationMinimumAmount' },
  { title: 'Produto', orderValue: 'productDisplay' },
  { title: 'Carência', orderValue: 'dueDate' },
  { title: 'Vencimento', orderValue: 'maturityDate' },
];

export const fixedIncomeConstants = {
  id: 'fixedIncome',
  typeGetterId: 'fixedIncome',
  title: 'Renda Fixa',
  operationId: 1,
  operationName: 'Aplicar',
  operationType: 'buy' as OperationType,
  color: 'product.rf' as ColorTypes.Option,
  principalComponent: FixedIncomeAsset,
  tableHead: fixedIncomeTableHead,
  hideTableHead: true,
  marketStatusSelector: fixedIncomeMarketStatusQuery,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      getRiskRatingLevelFilter('fixedIncome'),
      ...transformCustomFilters(customFilters),
      dailyLiquidityFilter,
      taxExemptFilter,
      profitabilityTypeFilter,
      monthsToRedemptionFilter,
      applicationAmountFilterNew,
      marketOptionFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'productSubCategory',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'productSubCategory'),
  captions: fixedIncomeCaptions,
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: true,
  unleashFlag: '',
  unleashFlagBatchTicket: Constant.UnleashBasketFixedIncomeToggle,
  unleashFlagCustomers: Constant.UnleashCustomersFixedIncomeToggle,
} as const;
